import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  Renderer2,
  SimpleChanges,
  HostListener
} from '@angular/core';
  import { IconTypes, ButtonDirection, HoverType } from './bari-button-scroll.type';

  @Component({
    selector: 'bari-button-scroll',
    templateUrl: './bari-button-scroll.component.html',
    styleUrls: ['./bari-button-scroll.component.scss'],
    entryComponents: []
  })
  export class BariButtonScrollComponent implements OnInit, OnChanges {
d
    @Input() icon: IconTypes;
    @Input() iconColor = '#fff';
    @Input() iconSize = 22;
    @Input() class: string;
    @Input() color: string;
    @Input() type = 'button';
    @Input() border: string;
    @Input() size: string;
    @Input() direction: ButtonDirection;
    @Input() decoration: string;
    @Input() padding: string;
    @Input() hover: HoverType;
    @Output() action = new EventEmitter();

    @Input()

    public showScroll: boolean;
    // Definit time to be displayed
    public showScrollHeight = 200;
    public hideScrollHeight = 10;

    private _nativeElement: ElementRef['nativeElement'];

    public iconFrames: { start?: number; end: number; final?: number; };

    constructor(private el: ElementRef, private renderer: Renderer2) {
      this._nativeElement = this.el.nativeElement;
    }

    @HostListener('window:scroll', [])
    onWindowScroll() {
      if (( window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop) > this.showScrollHeight) {
        this.showScroll = true;
      } else if ( this.showScroll && (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop)
      < this.hideScrollHeight ) {
        this.showScroll = false;
      }
    }

    private _addClassToButton(typeOfStyle: string, variantOfStyle: string) {

      const button = this._nativeElement.querySelector('button');
      const classes = button.classList.toString();
      const type = new RegExp(typeOfStyle);

      if (type.test(classes)) {
        const classesMatched = classes.match(type);
        const classToRemove = classesMatched.input.split(' ').filter(item => {
          return item.includes(typeOfStyle);
        })[0];
        this.renderer.removeClass(button, classToRemove);
      }

      if (/ /.test(variantOfStyle)) { // Check if has multiple variants for one style type
        variantOfStyle.split(' ').forEach(variant => {
          this.renderer.addClass(button, `btn-${typeOfStyle}-${variant}`);
        });
      } else {
        this.renderer.addClass(button, `btn-${typeOfStyle}-${variantOfStyle}`);
      }
    }


    private _validateClassToButton() {

      if (this.border) {
        this._addClassToButton('border', this.border);
      }

      if (this.color) {
        this._addClassToButton('color', this.color);
      }

      if (this.size) {
        this._addClassToButton('size', this.size);
      }

      if (this.padding) {
        this._addClassToButton('padding', this.padding);
      }

    }

    public onScrollTop() {

      (function smoothscroll() {
        const currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
        if (currentScroll > 0) {
          window.requestAnimationFrame(smoothscroll);
          window.scrollTo(0, currentScroll - (currentScroll / 5));
        }
      })();

    }
    public ngOnChanges(event: SimpleChanges) {
      // console.warn(event);
      this._validateClassToButton();

    }

    public click() {
      this.action.emit();
    }

    ngOnInit() {

    }


  }
